import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RedirectToNewAppGuard implements CanActivate {
  userId: number = 0;
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const isNewVersion = localStorage.getItem('isNewVersion');
    
    const currentPath = state.url.startsWith('/') ? state.url : '/' + state.url;
    const allowedRoutes = [
      '/props',
      '/props-myteams/upcoming',
      '/props-myteams/live',
      '/props-myteams/history',
      '/rankings',
      '/lobby',
      '/news',
      '/user/refer-friend',
      '/messages',
      '/register/welcome',
      '/responsible',
      '/myteams'
    ];
    const isMessagesRoute = currentPath.startsWith('/messages');
    const isOwnershipRoute = currentPath.startsWith('/ownership');
    const isDraftRoute = currentPath.startsWith('/draft');
    const isDraftaAllowed = isDraftRoute && (isNewVersion == 'true');
    if (allowedRoutes.includes(currentPath) || isMessagesRoute || isOwnershipRoute || isDraftaAllowed) {
      const redirectUrl = `${environment.NEW_SITE_URL}${currentPath}`;
      window.location.href = redirectUrl;
      return false;
    }else{
      window.location.href = `${environment.SITE_URL}/lobby`;
    }
  }
}